

import MY_CONFIG from "@/constants";
import { useLang } from "../context/TranslationProvider";

export default function NotFound() {
  const { t } = useLang();
  return (
    <div className=" h-screen flex flex-col items-center justify-center dark:text-white">
      <div className="pb-4">
        <img
          src={MY_CONFIG.LOGO_URL}
          alt="Not Found"
          className="w-64 h-64 md:w-96 md:h-96 rounded-full object-cover"
        />
      </div>
      <h1 className="text-2xl font-bold">{t("Sorry")}</h1>
      <p className="mt-4">{t("The Page Not Found")}</p>
    </div>
  );
}